import React from "react";
import ServiceDirectoryPage from "@/pages/ServiceDirectoryPage";

export default function BookLocalPage() {
  return (
    <ServiceDirectoryPage
      lockKind="local"
      eyebrow="Book local"
      headline="Book a Gulf Coast pro — today."
    />
  );
}
